import { apiClient, type Paginated } from '@/core/api';
import type { Note, NoteInput } from './types';

const BASE = '/collab/notes/';

export interface NoteListParams {
  page?: number;
  /** Filter to notes attached to a specific object (polymorphic GFK). */
  content_type?: number;
  object_id?: string | number;
  /** Only the current user's own notes (workspace Notes page). */
  mine?: boolean;
}

export async function listNotes(params: NoteListParams = {}): Promise<Paginated<Note>> {
  const { data } = await apiClient.get<Paginated<Note>>(BASE, { params });
  return data;
}

export async function createNote(input: NoteInput): Promise<Note> {
  const { data } = await apiClient.post<Note>(BASE, input);
  return data;
}

export async function updateNote(id: string | number, input: Partial<NoteInput>): Promise<Note> {
  const { data } = await apiClient.patch<Note>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteNote(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}
